// extracted by mini-css-extract-plugin
export var barContainer = "_2f-0";
export var extraThin = "_2f-3";
export var fillBar = "_2f-6";
export var fillContainer = "_2f-4";
export var overflow = "_2f-8";
export var overflowContainer = "_2f-5";
export var regular = "_2f-7";
export var thick = "_2f-1";
export var thin = "_2f-2";